// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"519":"051e8084","877":"818d0f38"}[chunkId] + ".css";
};